import React from 'react';
import Selectors from '@/themes/hooks/selectors';
import RequestRow from './RequestRow';

const RequestsTableRows = ({
  category,
  className,
  items,
  onCheckBoxClick,
  columns,
}) => {
  const { theme } = Selectors.useTheme();
  return (
    items.map((item, index) => (
      <RequestRow
        className={className}
        key={`requests_table_row_${item.code}`}
        category={category}
        request={item}
        onCheckBoxClick={onCheckBoxClick}
        upward={index > 4}
        columns={columns}
        theme={theme}
      />
    ))
  );
};

export default RequestsTableRows;
